import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { services } from './Services';
import { useHistory } from 'react-router-dom';
import * as track from '../../../lib/track';

const useStyles = makeStyles(theme => ({
  root: {
    padding: '1rem',
    width: '100%',
    height: '100%',
  },
  list: {
    paddingTop: '1rem',
  },
  listItem: {
    marginBottom: '1rem',
    padding: '0.1rem 0.8rem',
    color: theme.palette.primary.main,
    fontWeight: 500,
    borderLeft: `5px solid ${theme.palette.common.white}`,
    '&:hover': {
      borderLeft: `5px solid ${theme.palette.common.silver}`,
      backgroundColor: theme.palette.common.white,
    },
    '&:focus': {
      backgroundColor: theme.palette.common.white,
    },
  },
  selectedItem: {
    marginBottom: '1rem',
    padding: '0.1rem 0.8rem',
    color: theme.palette.primary.main,
    fontWeight: 500,
    borderLeft: `5px solid ${theme.palette.common.tealish}`,
    '&:hover': {
      backgroundColor: theme.palette.common.white,
    },
  },
}));

const Menu = ({service}) => {
  const classes = useStyles();
  const history = useHistory();
  const onClick = s => {
    track.sendEvent('user account service menu', 'click', {value: s.value});
    history.push({pathname: `/profile/${s.value}`, state: { service: s.value }});
  };
  return (
    <div className={classes.root}>
      <List className={classes.list}>
        {services.map(s => (
          <ListItem
            key={s.value}
            button
            disableRipple
            className={s.value === service.value ? classes.selectedItem : classes.listItem}
            onClick={() => onClick(s)}
          >
            <ListItemText primary={s.name} />
          </ListItem>
        ))}
      </List>
    </div>
  );
};

Menu.propTypes = {
  service: PropTypes.object.isRequired,
};

export default Menu;
